<template>
  <v-dialog v-model="termsDialog" width="900">
    <template v-slot:activator="{ on }">
      <v-checkbox
        @change="$emit('input', Boolean($event))"
        :value="value"
        color="secondary"
        data-e2e="signInAcceptTermsButton"
        :label="$t('signIn.acceptTermsLabel')"
        :error-messages="errors"
        :error-count="errors.length"
        :error="errors.length > 0"
      >
        <template v-slot:label>
          <span>
            <span>{{ $t('signIn.acceptTermsLabel') }} </span>
            <a v-on="on" @click.prevent class="Terms-toggle">{{ $t('signIn.acceptTermsLabelLink') }}*</a>
          </span>
        </template>
      </v-checkbox>
    </template>

    <v-card class="Terms-card">
      <v-card-title class="headline grey lighten-2" primary-title>
        {{ $t('TermsOfServices.modalTitle') }}
      </v-card-title>

      <v-card-text class="Terms-content py-5 px-12">
        <div v-if="cgu.length === 0" v-html="$t('TermsOfServices.cgu')" />
        <div v-else v-for="(el, i) in cgu" :key="i">
          <div class="TermsOfServices-cgu-title" v-html="el.title" />
          <div class="TermsOfServices-cgu-subtitle" v-html="el.subtitle" />
          <div class="TermsOfServices-cgu-text" v-html="el.text" />
        </div>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" text @click="handleAcceptTerms">
          {{ $t('TermsOfServices.acceptButton') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    errors: {
      type: Array,
      default: null
    },
    value: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      termsDialog: false
    }
  },

  computed: {
    cgu() {
      let cgu = []
      let i = 1

      while (!this.$t(`TermsOfServices.cgu.${this.pad(i)}-subtitle`).startsWith('TermsOfServices.cgu')) {
        cgu.push({
          subtitle: !this.$t(`TermsOfServices.cgu.${this.pad(i)}-subtitle`).startsWith('TermsOfServices.cgu')
            ? this.$t(`TermsOfServices.cgu.${this.pad(i)}-subtitle`)
            : '',
          text: !this.$t(`TermsOfServices.cgu.${this.pad(i)}-text`).startsWith('TermsOfServices.cgu')
            ? this.$t(`TermsOfServices.cgu.${this.pad(i)}-text`)
            : '',
          title: !this.$t(`TermsOfServices.cgu.${this.pad(i)}-title`).startsWith('TermsOfServices.cgu')
            ? this.$t(`TermsOfServices.cgu.${this.pad(i)}-title`)
            : ''
        })
        i++
      }

      return cgu
    }
  },

  watch: {
    acceptTerms(value) {
      this.$emit('input', value)
    }
  },

  methods: {
    handleAcceptTerms() {
      this.$emit('input', true)
      this.termsDialog = false
    },
    pad(value) {
      if (value < 10) {
        return '0' + value
      }

      return value.toString()
    }
  }
}
</script>

<style lang="scss" scoped>
.Terms-content {
  overflow-y: scroll;
  max-height: 75vh;
}

.TermsOfServices-cgu-title {
  margin: 1em 0;
  font-size: 1.6em;
  font-weight: 700;
}
.TermsOfServices-cgu-subtitle {
  margin-bottom: 0.5em;
  font-size: 1.2em;
  font-weight: 700;
}
.TermsOfServices-cgu-text {
  margin-bottom: 0.5em;
}
</style>
